<kiosk-wizard [step]="3">
  <div class="kiosk-hw100">
    <kiosk-template mainTitle="app.components.wizard.steps.scan-qr-code.title" image="scan-qr-code"> </kiosk-template>
    <!-- eslint-disable-next-line @angular-eslint/template/no-autofocus -->
    <input type="text" autofocus #scanInput (blur)="onBlur($event)" class="hidden-input" />
  </div>
</kiosk-wizard>